// src/data/greenlee.ts
var greenleeHandBender = {
  id: "greenlee-hand-bender",
  manufacturer: "Greenlee",
  model: "Site-Rite Hand Bender (840/841/842)",
  description: 'Hand bender for 1/2", 3/4", and 1" EMT',
  source: "Greenlee Site-Rite Hand Benders Manual 52034125 REV 02",
  sourceUrls: [
    "https://cdn.greenlee.com/resources/media?key=1adba548-f1d2-43d2-bf44-fe4b89a8b579&languageCode=en&type=document",
    "https://www.greenlee.com/us/en/benderhand---1-2-emt-840f",
    "https://www.greenlee.com/us/en/benderhand---3-4-emt--1-2-rigid-841f",
    "https://www.greenlee.com/us/en/benderhand---1-emt--3-4-rigid-842a"
  ],
  verificationStatus: "partial",
  verificationNotes: "Manufacturer manual verifies deduct/take-up and bend radius; gain still needs a manufacturer source.",
  verified: false,
  shoes: [
    {
      conduitSize: "1/2",
      material: "EMT",
      gain: 1.5,
      takeUp: 5,
      minRadius: 4.1875,
      verifiedFields: ["takeUp", "minRadius"]
    },
    {
      conduitSize: "3/4",
      material: "EMT",
      gain: 2.25,
      takeUp: 6,
      minRadius: 5.125,
      verifiedFields: ["takeUp", "minRadius"]
    },
    {
      conduitSize: "1",
      material: "EMT",
      gain: 3.5,
      takeUp: 8,
      minRadius: 6.5,
      verifiedFields: ["takeUp", "minRadius"]
    }
  ]
};
var greenlee555 = {
  id: "greenlee-555",
  manufacturer: "Greenlee",
  model: "555",
  description: 'Mechanical bender, 1/2" through 2" EMT/Rigid',
  source: "Greenlee 555C Electric Bender Classic Instruction Manual deduct table",
  sourceUrls: [
    "https://cdn.greenlee.com/resources/media?key=c621b4f4-74d7-4f13-9e55-148f75359848&languageCode=en&type=document"
  ],
  verificationStatus: "partial",
  verificationNotes: "Greenlee 555C manual verifies 90-degree stub deduct/take-up values for EMT and rigid/PVC conduit; gain still needs a manufacturer source.",
  verified: false,
  shoes: [
    // EMT
    { conduitSize: "1/2", material: "EMT", gain: 1.5, takeUp: 7, verifiedFields: ["takeUp"] },
    {
      conduitSize: "3/4",
      material: "EMT",
      gain: 2.25,
      takeUp: 8.875,
      verifiedFields: ["takeUp"]
    },
    { conduitSize: "1", material: "EMT", gain: 3.5, takeUp: 10.75, verifiedFields: ["takeUp"] },
    {
      conduitSize: "1-1/4",
      material: "EMT",
      gain: 5,
      takeUp: 13.125,
      verifiedFields: ["takeUp"]
    },
    {
      conduitSize: "1-1/2",
      material: "EMT",
      gain: 6,
      takeUp: 13.875,
      verifiedFields: ["takeUp"]
    },
    { conduitSize: "2", material: "EMT", gain: 8, takeUp: 15.375, verifiedFields: ["takeUp"] },
    // Rigid/PVC row from the manual's Deduct Table.
    {
      conduitSize: "1/2",
      material: "RIGID",
      gain: 1.5,
      takeUp: 7.5,
      verifiedFields: ["takeUp"]
    },
    { conduitSize: "3/4", material: "RIGID", gain: 2.25, takeUp: 9, verifiedFields: ["takeUp"] },
    { conduitSize: "1", material: "RIGID", gain: 3.5, takeUp: 11, verifiedFields: ["takeUp"] },
    { conduitSize: "1-1/4", material: "RIGID", gain: 5, takeUp: 14, verifiedFields: ["takeUp"] },
    {
      conduitSize: "1-1/2",
      material: "RIGID",
      gain: 6,
      takeUp: 14.25,
      verifiedFields: ["takeUp"]
    },
    { conduitSize: "2", material: "RIGID", gain: 8, takeUp: 16.125, verifiedFields: ["takeUp"] }
  ]
};

// src/data/klein.ts
var kleinHandBender = {
  id: "klein-hand-bender",
  manufacturer: "Klein Tools",
  model: "51606/51607 Hand Bender",
  description: 'Hand bender for 1/2" and 3/4" EMT',
  source: "Klein Tools 51606 and 51607 product specifications",
  sourceUrls: [
    "https://www.kleintools.com/catalog/conduit-benders-and-parts/aluminum-conduit-bender-full-assembly-12-inch-emt-angle-setter",
    "https://www.kleintools.com/catalog/conduit-benders-and-parts/aluminum-conduit-bender-full-assembly-34-inch-emt-angle-setter"
  ],
  verificationStatus: "partial",
  verificationNotes: "Klein specifications verify stub-up height and centerline bend radius; gain still needs a manufacturer source.",
  verified: false,
  shoes: [
    {
      conduitSize: "1/2",
      material: "EMT",
      gain: 1.5,
      takeUp: 5,
      minRadius: 4.625,
      verifiedFields: ["takeUp", "minRadius"]
    },
    {
      conduitSize: "3/4",
      material: "EMT",
      gain: 2.25,
      takeUp: 6,
      minRadius: 5.5,
      verifiedFields: ["takeUp", "minRadius"]
    }
  ]
};

// src/data/ideal.ts
var idealBigKahuna = {
  id: "ideal-big-kahuna",
  manufacturer: "Ideal Industries",
  model: "Big Kahuna",
  description: 'Mechanical bender, 1-1/4" through 2" EMT/Rigid',
  source: "Ideal Big Kahuna trade-standard markings",
  verified: false,
  shoes: [
    { conduitSize: "1-1/4", material: "EMT", gain: 5, takeUp: 11 },
    { conduitSize: "1-1/2", material: "EMT", gain: 6, takeUp: 13 },
    { conduitSize: "2", material: "EMT", gain: 8, takeUp: 17 },
    { conduitSize: "1-1/4", material: "RIGID", gain: 5, takeUp: 11.5 },
    { conduitSize: "1-1/2", material: "RIGID", gain: 6, takeUp: 13.5 },
    { conduitSize: "2", material: "RIGID", gain: 8, takeUp: 17.5 }
  ]
};

// src/data/ridgid.ts
var ridgid600 = {
  id: "ridgid-600",
  manufacturer: "Ridgid",
  model: "600 Hydraulic",
  description: 'Hydraulic bender for 2-1/2" through 4" Rigid',
  source: "Ridgid 600 series trade knowledge",
  verified: false,
  shoes: [
    { conduitSize: "2-1/2", material: "RIGID", gain: 11, takeUp: 22 },
    { conduitSize: "3", material: "RIGID", gain: 13, takeUp: 26 },
    { conduitSize: "3-1/2", material: "RIGID", gain: 15, takeUp: 30 },
    { conduitSize: "4", material: "RIGID", gain: 17, takeUp: 34 }
  ]
};

// src/data/gardner-bender.ts
var gardnerHandBender = {
  id: "gardner-bender-hand",
  manufacturer: "Gardner Bender",
  model: "Hand Bender (930B/931B/932)",
  description: 'Hand bender for 1/2", 3/4", and 1" EMT',
  source: "Gardner Bender B-0040 Hand Bending Guide",
  sourceUrls: ["https://www.gardnerbender.com/-/media/inriver/B-0040.pdf?modified=20200714152031"],
  verificationStatus: "partial",
  verificationNotes: "Gardner Bender hand bending guide verifies EMT deduct/take-up and bend radius; gain still needs a manufacturer source.",
  verified: false,
  shoes: [
    {
      conduitSize: "1/2",
      material: "EMT",
      gain: 1.5,
      takeUp: 5,
      minRadius: 5,
      verifiedFields: ["takeUp", "minRadius"]
    },
    {
      conduitSize: "3/4",
      material: "EMT",
      gain: 2.25,
      takeUp: 6,
      minRadius: 6,
      verifiedFields: ["takeUp", "minRadius"]
    },
    {
      conduitSize: "1",
      material: "EMT",
      gain: 3.5,
      takeUp: 8,
      minRadius: 8,
      verifiedFields: ["takeUp", "minRadius"]
    }
  ]
};

// src/registry.ts
var ALL_BENDERS = [
  greenleeHandBender,
  kleinHandBender,
  gardnerHandBender,
  greenlee555,
  idealBigKahuna,
  ridgid600
];
function getBender(id) {
  return ALL_BENDERS.find((b) => b.id === id);
}
function listBenders() {
  return ALL_BENDERS.slice();
}
function listManufacturers() {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const b of ALL_BENDERS) {
    if (!seen.has(b.manufacturer)) {
      seen.add(b.manufacturer);
      out.push(b.manufacturer);
    }
  }
  return out;
}
function getShoe(benderId, conduitSize, material) {
  const bender = getBender(benderId);
  if (!bender) return void 0;
  return bender.shoes.find((s) => s.conduitSize === conduitSize && s.material === material);
}
function getSupportedSizes(benderId, material) {
  const bender = getBender(benderId);
  if (!bender) return [];
  const matchingShoes = material ? bender.shoes.filter((s) => s.material === material) : bender.shoes;
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const s of matchingShoes) {
    if (!seen.has(s.conduitSize)) {
      seen.add(s.conduitSize);
      out.push(s.conduitSize);
    }
  }
  return out;
}
function getVerificationSummary(bender) {
  const status = verificationStatusFor(bender);
  const relevantFields = fieldsFor(bender);
  let sourcedFieldCount = 0;
  let totalFieldCount = 0;
  const missing = /* @__PURE__ */ new Set();
  for (const shoe of bender.shoes) {
    for (const field of relevantFields) {
      if (field === "minRadius" && typeof shoe.minRadius !== "number") continue;
      if (field === "deductPerDegree" && typeof shoe.deductPerDegree !== "number") continue;
      totalFieldCount += 1;
      if (shoe.verifiedFields?.includes(field)) {
        sourcedFieldCount += 1;
      } else {
        missing.add(field);
      }
    }
  }
  return {
    status,
    label: labelFor(status),
    sourcedFieldCount,
    totalFieldCount,
    sourceCount: bender.sourceUrls?.length ?? 0,
    missingFields: Array.from(missing)
  };
}
function listBenderVerificationIssues(benders = ALL_BENDERS) {
  return benders.flatMap((bender) => {
    const summary = getVerificationSummary(bender);
    if (summary.status === "verified") return [];
    return [
      {
        benderId: bender.id,
        manufacturer: bender.manufacturer,
        model: bender.model,
        status: summary.status,
        label: summary.label,
        missingFields: summary.missingFields,
        sourceCount: summary.sourceCount,
        notes: bender.verificationNotes ?? "No manufacturer source linked yet."
      }
    ];
  });
}
function listPublicBenderReleaseBlockers(benders = ALL_BENDERS) {
  return listBenderVerificationIssues(benders).filter((issue) => {
    if (issue.status === "field-reference") return false;
    return issue.missingFields.some((field) => field !== "gain");
  });
}
function listPublicBenderReleaseWarnings(benders = ALL_BENDERS) {
  const warnings = [];
  for (const issue of listBenderVerificationIssues(benders)) {
    if (issue.status === "field-reference") {
      warnings.push({ ...issue, reason: "field-reference-not-selectable" });
      continue;
    }
    if (issue.missingFields.length > 0 && issue.missingFields.every((field) => field === "gain")) {
      warnings.push({ ...issue, reason: "estimated-gain" });
    }
  }
  return warnings;
}
function verificationStatusFor(bender) {
  return bender.verificationStatus ?? (bender.verified ? "verified" : "field-reference");
}
function labelFor(status) {
  if (status === "verified") return "Verified";
  if (status === "partial") return "Partially verified";
  return "Field reference";
}
function fieldsFor(bender) {
  const fields = ["gain", "takeUp"];
  if (bender.shoes.some((shoe) => typeof shoe.minRadius === "number")) fields.push("minRadius");
  if (bender.shoes.some((shoe) => typeof shoe.deductPerDegree === "number")) {
    fields.push("deductPerDegree");
  }
  return fields;
}

export { ALL_BENDERS, gardnerHandBender, getBender, getShoe, getSupportedSizes, getVerificationSummary, greenlee555, greenleeHandBender, idealBigKahuna, kleinHandBender, listBenderVerificationIssues, listBenders, listManufacturers, listPublicBenderReleaseBlockers, listPublicBenderReleaseWarnings, ridgid600 };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map